export enum PosProviderType {
  UnTill = "untill",
  MPlusKassa = "mpluskassa",
  Unitouch = "unitouch",
  Povis = "povis",
  PosEmulator = "pos_emulator",
}

export type PosConnectionStatus =
  "CONNECTED" | "PENDING" | "BAD_CREDENTIALS" | "DELETED";

export type PosEmulatorScenarioId =
  | "default"
  | "large-order"
  | "single-item"
  | "vat-mix"
  | "no-active-order"
  | "closed-order"
  | "custom";

export const POS_EMULATOR_PRESET_SCENARIO_IDS: Exclude<
  PosEmulatorScenarioId,
  "custom"
>[] = [
  "default",
  "large-order",
  "single-item",
  "vat-mix",
  "no-active-order",
  "closed-order",
];

export const POS_EMULATOR_SCENARIO_IDS: PosEmulatorScenarioId[] = [
  ...POS_EMULATOR_PRESET_SCENARIO_IDS,
  "custom",
];

export interface UnTillCredentials {
  userName: string;
  password: string;
  dbName: string;
}

export interface MPlusKassaCredentials {
  ident: string;
  secret: string;
  endpoint?: string;
  terminalNumber?: number;
  defaultWorkplaceNumber?: number;
}

export interface UnitouchCredentials {
  channelId: string;
  mac: string;
  loginName: string;
  loginPass: string;
  myPassword: string;
  baseUrl?: string;
  usrPK?: number;
  usrCashReg?: number;
  payMode?: number;
  currencyId?: number;
  tipPayMode?: number;
  waiterPK?: number;
  waiterName?: string;
}

export interface PovisCredentials {
  clientId: string;
  clientSecret: string;
  apiKey: string;
  posId: string;
  employeeId: string;
  paymentMethod?: string;
  platform?: string;
}

export type PosEmulatorCredentials = Record<string, never>;

export type PosCredentials =
  | UnTillCredentials
  | MPlusKassaCredentials
  | UnitouchCredentials
  | PovisCredentials
  | PosEmulatorCredentials;

export interface PosTable {
  posTableId: string;
  label: string;
  metadata: Record<string, unknown>;
}

export interface PosOrderItem {
  name: string;
  quantity: number;
  unitPrice: number;
  totalPrice: number;
  vatRate?: number;
}

export interface PosOrder {
  posTableId: string;
  posOrderId: string;
  totalAmount: number;
  remainingAmount: number;
  paidAmount: number;
  currency: string;
  items: PosOrderItem[];
}

export interface PosItem {
  articleId?: number;
  productReference?: string;
  name: string;
  unitPrice?: number;
  vatRate?: number;
}

export interface ManualOrderItem {
  _localId: string;
  articleId?: number;
  productReference?: string;
  name: string;
  quantity: number;
  unitPrice?: number;
  vatRate?: number;
}

export interface ConnectToPosResponse {
  posConnectionId: string;
  status: PosConnectionStatus;
}
